import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { Row, DayColumn, Column, Grid } from '../../../../../../common/ui/styled';
import { Add } from './add';
import { ConnectedTimePickers, defaultWorkHours } from './connected-time-pickers';
import { DayCheckbox } from './day';
import { Remove, WithRowsActiveCellBase } from './remove';
import { UseWorkingTimesState } from './state';
import type { DefaultWorkingTimes } from './state/types.tsx';

type Props = {
	day: string;
	defaultWorkingTimes?: DefaultWorkingTimes;
};

export const DayWithHours = ({ day, defaultWorkingTimes }: Props) => {
	const [{ workingTimes, isDaySelected }, { onRemove, onAdd, setDaySelected }] =
		UseWorkingTimesState(defaultWorkingTimes, defaultWorkHours);
	return (
		<Row>
			<DayColumn>
				<DayCheckbox
					fieldName={day}
					defaultIsChecked={isDaySelected}
					setDaySelected={setDaySelected}
				/>
			</DayColumn>
			<Column>
				{workingTimes.map(({ fieldId, ...value }) => (
					<WithRowsActiveCellBase key={`${day}${fieldId}`}>
						<Grid>
							<ConnectedTimePickers
								day={day}
								defaultValue={value}
								fieldId={fieldId}
								isDisabled={!isDaySelected}
							/>
							<RemoveColumn>
								{isDaySelected && <Remove day={day} onRemove={() => onRemove(fieldId)} />}
							</RemoveColumn>
						</Grid>
					</WithRowsActiveCellBase>
				))}
			</Column>
			<Box xcss={addColumnStyles}>
				<Add day={day} isDisabled={!isDaySelected} onAdd={onAdd} />
			</Box>
		</Row>
	);
};

const addColumnStyles = xcss({
	marginTop: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RemoveColumn = styled.div({
	marginLeft: token('space.025', '2px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	flexBasis: `${gridSize * 5}px`,
});
